export default "__VITE_ASSET__c92588c9__"